module.exports = __webpack_public_path__ + "static/media/desktop2.c3d7c1d5.png";